import { render, staticRenderFns } from "./OAuthAuthorize.vue?vue&type=template&id=2c9f5500&scoped=true"
import script from "./OAuthAuthorize.vue?vue&type=script&lang=ts"
export * from "./OAuthAuthorize.vue?vue&type=script&lang=ts"
import style0 from "./OAuthAuthorize.vue?vue&type=style&index=0&id=2c9f5500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9f5500",
  null
  
)

export default component.exports